export default __webpack_public_path__ + "static/media/Product_11.acbd270b.JPG";